import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Elm Street Academy Presents Social Media and Online Marketing Masterclasses - Elm Street Technology</title>
        <meta name="description" content="Social Media and Online Marketing Masterclasses presented by Elm Street Academy - Elm Street Technology" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/masterclass" />
        <meta property="og:title" content="Social Media and Online Marketing Masterclasses presented by Elm Street Academy - Elm Street Technology" />
        <meta property="og:description" content="Social Media and Online Marketing Masterclasses presented by Elm Street Academy - Elm Street Technology" />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('mcbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Academy - Social Media and Online MArketing Masterclasses"
      >
        <Container columnSpacing={8}>
          <Grid container>
            <Grid item md={12} sm={12} style={{ paddingBottom: "84px", textAlign:"center", paddingTop:"74px", paddingLeft:"35px", paddingRight:"35px", }}>
             
               
                  
                    <div style={{ paddingTop: "8px" }}>
                      <Image src="/amc.png" width="550px" height="209px" alt="Elm Street Academy Presents Social Media and Online MArketing Masterclasses" />
                    </div>
                    
                    <span style={{ color: "#ffffff" }}><strong>In-Person Experience. Inspiring Education.<br />
                    Fun Learning Environment.</strong></span><br /><br />
                  <Button variant="contained" color="secondary" href="#form">
                    book your event!
                  </Button>
                
             
            </Grid>
          </Grid>
        </Container>
      </div>



      <div>
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "60px", paddingLeft:"35px", paddingRight:"35px", }}>
          <Grid container columnSpacing={8}>
            <Grid item md={12} sm={12} style={{ paddingBottom: "24px", textAlign:"center", }}>
              
              <span>Social media and marketing are crucial, but most agents aren't maximizing their value due to a lack
              of knowledge, fear of “messing up,” lack of time, or all of the above.
<br /><br />
Our goal is to CHANGE THAT by providing empowering and results-driven education to individual office groups. 
<br /><br />
We use humor, practical advice and real-life experiences to break down the walls that keep real estate professionals
from utilizing social media and marketing practices to their fullest potential.
</span>
             
            </Grid>

          
          </Grid>
        </Container>
      </div>




      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingBottom: "80px",
        }}
      >
 

        <Grid container spacing={16}>
          <Grid item md={6} sm={12} style={{ paddingBottom: "10px", textAlign: "left" }}>
 
              <Typography variant="h3" component="h3">WE TEACH<br />
              TOPICS THAT 
              <br /><span style={{ color: mainTheme.palette.secondary.main }}>HELP AGENTS THRIVE!</span></Typography>
              <br />
              <strong style={{ color: mainTheme.palette.secondary.main }}>TOPICS INCLUDE:</strong><br />
              - Social Media<br />
              - Lead Generation<br />
              - Lead Nurturing<br />
              - Repeat/Referral<br />
              - Marketing Strategies<br />
              - Lead Conversion<br />
              - Technology Training<br />
              &amp; MUCH MORE!

          </Grid>
          <Grid item md={6} sm={12} style={{ paddingBottom: "10px", textAlign: "left" }}>
          <strong style={{ color: mainTheme.palette.secondary.main }}>HOW IT WORKS:</strong><br />
          We partner with you to bring an educational experience to your office that INSPIRES, MOTIVATES &amp; CREATES EXCITEMENT!
            <br /><br />
          You provide the space and which topic you would like us to cover with your organization. We provide action-oriented education, and a fun experience that will have attendees asking for more!
          <br /><br />
          <strong style={{ color: mainTheme.palette.secondary.main }}>THE BEST PART?</strong><br />
          <strong>ALL EDUCATIONAL EXPERIENCES<br />
            ARE FREE TO HOST!</strong>

          </Grid>
        </Grid>
      </Container>




      <div
        style={{
          backgroundImage: "url('horizonbg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "95px",
            paddingBottom: "65px",
          }}
        >
          <Grid container columnSpacing={16}>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
              “I've found my 'why' when it comes to my online brand, and now I have more leads and referrals than ever before! No more scrambling for business.”
                <br />
                <strong style={{ color: "#f69c26" }}>Jennifer M.</strong>
                <br />
                Denver, CO
              </span>
            </Grid>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
              “I've saved an entire workday by automating my daily tasks. I had no idea I was wasting so much time with busy work.”
                <br />
                <strong style={{ color: "#f69c26" }}>Francis K.</strong>
                <br />
                Boston, MA
              </span>
            </Grid>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <span style={{ color: "#ffffff" }}>
                “I feel empowered and ready to conquer my marketing and lead generation. It's so much easier than I
                thought.”
                <br />
                <strong style={{ color: "#f69c26" }}>Ayesha D.</strong>
                <br />
                Miami, FL
              </span>
            </Grid>
          </Grid>
        </Container>
      </div>







      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
          <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              Book your Masterclass
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                Schedule an Experience for Your Office Today!
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Book an Event"
                      successUrl="thankyou"
                      listId="148005"
                      formName="es2_masterclass"                      
                      fieldList={["first_name", "last_name", "email", "phone", "num_agents", "city", "state", "company", "masterclass_interests"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
